import { Link } from "react-router-dom";
import "./Footer.scss";
import gitHubLogo from "../../assets/icons/github.png";
import emailIcon from "../../assets/icons/email.svg";
import linkedInLogo from "../../assets/icons/linkedIn.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__lead">
          <p className="footer__eyebrow">Old melodies, new ears</p>
          <p className="footer__wordmark">ClassiFind</p>
        </div>

        <div className="footer__cols">
          <nav className="footer__col" aria-label="Explore">
            <span className="footer__col-label">Explore</span>
            <Link to="/quiz">Search</Link>
            <Link to="/finds">My Finds</Link>
            <Link to="/">Home</Link>
          </nav>

          <div className="footer__col">
            <span className="footer__col-label">Made by</span>
            <a href="https://github.com/madisonmarino" target="_blank" rel="noreferrer">
              Madison Marino
            </a>
            <div className="footer__socials">
              <a href="mailto:marinomadison@gmail.com" title="Email">
                <img src={emailIcon} alt="Email" />
              </a>
              <a href="https://github.com/madisonmarino" target="_blank" rel="noreferrer" title="GitHub">
                <img src={gitHubLogo} alt="GitHub" />
              </a>
              <a href="https://www.linkedin.com/in/-madison-marino/" target="_blank" rel="noreferrer" title="LinkedIn">
                <img src={linkedInLogo} alt="LinkedIn" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__base">
        <span>© {new Date().getFullYear()} ClassiFind</span>
        <span>Spotify × Gemini</span>
      </div>
    </footer>
  );
}
